__turbopack_context__.v({
  "className": "caveat_d77b845d-module__HoCYJa__className",
});
